import http from "./httpClient.js";

export async function getDiscoverSchools() {
    const response = await http.get(`/school/discover-map`);
    return response.data;
}
